export enum TICKET_STATUS {
    NEW = 'new',
    IN_PROGRESS = 'in_progress',
    RESOLVED = 'resolved',
    REOPEN = 'reopened'

}
